import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    error: null,
    requests: [],
    // _id of the request currently being rejected (drives the row's button state)
    rejectingId: null,
    // true while an approve (tracker confirmation) is in flight
    isApproving: false,
};

const slice = createSlice({
    name: 'manualTimeRequest',
    initialState,
    reducers: {
        fetchRequests: state => {
            state.isLoading = true;
            state.error = null;
        },
        requestsFetched: (state, { payload }) => {
            state.requests = (payload && payload.results) || [];
            state.isLoading = false;
        },
        requestsFetchFailed: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload || 'Failed to load manual time requests';
        },
        rejectRequest: (state, { payload }) => {
            state.rejectingId = payload.id;
            state.error = null;
        },
        rejectSucceeded: (state, { payload }) => {
            state.rejectingId = null;
            // Rejected requests are no longer pending — drop them from the list.
            state.requests = state.requests.filter(r => r._id !== payload.id);
        },
        rejectFailed: (state, { payload }) => {
            state.rejectingId = null;
            state.error = payload || 'Failed to reject manual time request';
        },
        approveRequest: state => {
            state.isApproving = true;
            state.error = null;
        },
        approveSucceeded: (state, { payload }) => {
            state.isApproving = false;
            // Approved requests are no longer pending — drop them from the list.
            state.requests = state.requests.filter(r => r._id !== payload.id);
        },
        approveFailed: (state, { payload }) => {
            state.isApproving = false;
            state.error = payload || 'Failed to approve manual time request';
        },
    },
});

export const {
    fetchRequests,
    requestsFetched,
    requestsFetchFailed,
    rejectRequest,
    rejectSucceeded,
    rejectFailed,
    approveRequest,
    approveSucceeded,
    approveFailed,
} = slice.actions;

export default slice.reducer;

export const selectManualTimeRequestState = state => state.manualTimeRequest;
